import React from 'react';
import { Form, Button } from 'tabler-react';
import toast from 'cogo-toast';
import Request from '../../shared/request';

class Exchange extends React.Component {
  state = {
    code: null,
  };

  exchange = async () => {
    if (!this.state.code) {
      toast.error('请输入充值卡密码兑换');
      return;
    }

    const result = await Request.call('activeCard', {
      code: this.state.code,
    });

    if (result) {
      toast.success(`成功兑换${result.days}天，如果时间未更新请刷新页面`);
      window.location.reload();
    }
  };

  render() {
    return (
      <Form.InputGroup>
        <Form.Input
          color="yellow"
          placeholder="输入你的充值卡或体验卡"
          onChange={event => {
            this.setState({ code: event.target.value });
          }}
        />
        <Form.InputGroupAppend>
          <Button RootComponent="div" onClick={this.exchange} color="primary">
            激活卡密
          </Button>
        </Form.InputGroupAppend>
      </Form.InputGroup>
    );
  }
}

export default Exchange;
